import ReactGA4 from 'react-ga4';
import {
    isServer,
} from 'shared/utils'
import { telemetryAllowed } from './telemetry'

let GA4_TRACKING_ID = process.env.REACT_APP_GA4_TRACKING_ID

export const setTrackingId = () => {
    if (GA4_TRACKING_ID && telemetryAllowed()) {
        console.log('Set GA4 Tracking ID', GA4_TRACKING_ID)
        ReactGA4.initialize(GA4_TRACKING_ID);
        ReactGA4.set({ anonymizeIp: true });
        // ReactGA4.pageview(window.location.pathname + window.location.search);
        ReactGA4.send('pageview', { page: window.location.pathname + window.location.search });
    }
}

if (GA4_TRACKING_ID && !isServer()) {
    setTrackingId()
}

export const event = ev => {
    if (!telemetryAllowed()) return
    if (!GA4_TRACKING_ID) {
        console.log('Ignore analytics event on dev', ev)
        return
    }
    ReactGA4.event(ev)
}
export const pageview = path => {
    if (!telemetryAllowed(path)) return
    if (!GA4_TRACKING_ID) {
        console.log('Ignore analytics pageview on dev', path)
        return
    }
    // ReactGA4.pageview(path)
    ReactGA4.send('pageview', { page: path });
}
